
(function () {
  "use strict";

  function initMvdCart() {
    if (window.__mvdCartInitialized) return;

    const drawer = document.getElementById("mvd-cart-drawer");
    const overlay = document.getElementById("mvd-cart-overlay");

    if (!drawer || !overlay) return;

    window.__mvdCartInitialized = true;

    const path = window.location.pathname;
    const lang = path.startsWith("/en")
      ? "en"
      : path.startsWith("/es")
        ? "es"
        : "fr";

    const translations = {
      fr: {
        title: "Mon Panier",
        empty: "Votre panier est vide",
        continue: "Continuer mes achats",
        free: "🎁 Félicitations, vous avez débloqué la livraison offerte !",
        missing: "Plus que {amount} pour profiter de la livraison offerte",
        remove: "Supprimer",
        save: "🏷 Vous économisez {percent} %",
        upsell: "✨ Complétez votre kit de Diamond Painting",
        add: "Ajouter au panier",
        adding: "Ajout...",
        sale: "PROMO -{percent} %",
        promo: "Un code promo ?",
        promoPlaceholder: "Votre code",
        apply: "Appliquer",
        applying: "Application...",
        promoApplied: "✓ Code promo appliqué",
        promoInvalid: "Ce code promo ne semble pas applicable.",
        promoEmpty: "Saisissez votre code promo.",
        discount: "Remises",
        savings: "Économies totales",
        checkout: "Passer la commande • {total}",
        delivery: "🚚 Livraison rapide Mondial Relay · 3–5 jours ouvrés",
        threshold: 6000,
        locale: "fr-FR",
        currency: "EUR",
        prefix: "",
        collection: "/collections/accessoires-diamond-painting/products.json?limit=250"
      },

      es: {
        title: "Mi carrito",
        empty: "Tu carrito está vacío",
        continue: "Seguir comprando",
        free: "🎁 ¡Enhorabuena! Has conseguido el envío gratis.",
        missing: "Te faltan {amount} para conseguir el envío gratis",
        remove: "Eliminar",
        save: "🏷 Ahorras un {percent} %",
        upsell: "✨ Completa tu kit de Diamond Painting",
        add: "Añadir al carrito",
        adding: "Añadiendo...",
        sale: "OFERTA -{percent} %",
        promo: "¿Tienes un código promocional?",
        promoPlaceholder: "Tu código",
        apply: "Aplicar",
        applying: "Aplicando...",
        promoApplied: "✓ Código promocional aplicado",
        promoInvalid: "Este código promocional no parece aplicarse.",
        promoEmpty: "Introduce tu código promocional.",
        discount: "Descuentos",
        savings: "Ahorro total",
        checkout: "Finalizar compra • {total}",
        delivery: "🚚 Envío rápido vía InPost · 4–6 días laborables",
        threshold: 6000,
        locale: "es-ES",
        currency: "EUR",
        prefix: "/es",
        collection: "/es/collections/accessoires-diamond-painting/products.json?limit=250"
      },

      en: {
        title: "My Cart",
        empty: "Your cart is empty",
        continue: "Continue shopping",
        free: "🎁 Congratulations! You unlocked Free Shipping!",
        missing: "Only {amount} away from Free Shipping",
        remove: "Remove",
        save: "🏷 You save {percent}%",
        upsell: "✨ Complete Your Diamond Painting Kit",
        add: "Add to cart",
        adding: "Adding...",
        sale: "SALE -{percent}%",
        promo: "Have a promo code?",
        promoPlaceholder: "Promo code",
        apply: "Apply",
        applying: "Applying...",
        promoApplied: "✓ Promo code applied",
        promoInvalid: "This promo code does not appear to apply.",
        promoEmpty: "Enter your promo code.",
        discount: "Discounts",
        savings: "Total savings",
        checkout: "Checkout • {total}",
        delivery: "📦 French brand • Shipping to the United States",
        threshold: 7000,
        locale: "en-US",
        currency: "USD",
        prefix: "/en",
        collection: "/en/collections/accessories/products.json?limit=250"
      }
    };

    const T = translations[lang];

    const $ = id => document.getElementById(id);

    const cartTitle = $("mvd-cart-title");
    const closeButton = $("mvd-cart-close");
    const shippingText = $("mvd-shipping-text");
    const shippingProgress = $("mvd-shipping-progress");
    const items = $("mvd-cart-items");
    const empty = $("mvd-cart-empty");
    const emptyText = $("mvd-empty-text");
    const continueButton = $("mvd-cart-continue");
    const upsell = $("mvd-cart-upsell");
    const upsellTitle = $("mvd-upsell-title");
    const slider = $("mvd-upsell-slider");
    const prev = $("mvd-upsell-prev");
    const next = $("mvd-upsell-next");
    
/* MVD — Accessoires ouverts par défaut,
   fermeture avec × et réouverture avec + */

if (upsell && upsellTitle && slider) {
  const upsellHeader = upsellTitle.closest(".mvd-upsell-head");

  if (upsellHeader && !upsell.querySelector(".mvd-upsell-collapse")) {
    const toggle = document.createElement("button");

    toggle.type = "button";
    toggle.className = "mvd-upsell-collapse";

    let expanded = true;

    function updateUpsell() {
      upsell.classList.toggle("mvd-collapsed", !expanded);
      toggle.textContent = expanded ? "×" : "+";
      toggle.setAttribute("aria-expanded", String(expanded));
      toggle.setAttribute(
        "aria-label",
        expanded ? "Masquer les accessoires" : "Afficher les accessoires"
      );
    }

    toggle.addEventListener("click", function() {
      expanded = !expanded;
      updateUpsell();
    });

    upsellHeader.appendChild(toggle);
    updateUpsell();
  }
}

    const promoToggle = $("mvd-promo-toggle");
    const promoContent = $("mvd-promo-content");
    const promoSymbol = $("mvd-promo-symbol");
    const promoTitle = $("mvd-promo-title");
    const promoInput = $("mvd-promo-input");
    const promoApply = $("mvd-promo-apply");
    const promoMessage = $("mvd-promo-message");
    const activeDiscounts = $("mvd-active-discounts");
    const activeDiscountsTitle = $("mvd-active-discounts-title");
    const activeDiscountTags = $("mvd-active-discount-tags");
    const savingTitle = $("mvd-saving-title");
    const savingValue = $("mvd-saving-value");
    const checkout = $("mvd-checkout");
    const delivery = $("mvd-delivery");

    cartTitle.textContent = T.title;
    emptyText.textContent = T.empty;
    continueButton.textContent = T.continue;
    upsellTitle.textContent = T.upsell;
    promoTitle.textContent = T.promo;
    promoInput.placeholder = T.promoPlaceholder;
    promoApply.textContent = T.apply;
    activeDiscountsTitle.textContent = T.discount;
    savingTitle.textContent = T.savings;
    delivery.textContent = T.delivery;

    const originalFetch = window.fetch.bind(window);

    let accessoryProducts = null;
    let accessoryPromise = null;
    let cartOperation = Promise.resolve();
    let refreshOperation = Promise.resolve();
    let currentCart = null;
    let promoOpen = false;

    const localizedProducts = {};

    function money(cents) {
      return (Number(cents || 0) / 100).toLocaleString(
        T.locale,
        {
          style: "currency",
          currency: T.currency
        }
      );
    }

    function safeText(value) {
      const element = document.createElement("div");
      element.textContent = String(value || "");
      return element.innerHTML;
    }

    function cartUrl(endpoint) {
      const root = window.Shopify &&
        window.Shopify.routes &&
        window.Shopify.routes.root
          ? window.Shopify.routes.root
          : "/";

      return root.replace(/\/?$/, "/") + endpoint;
    }

    async function getCart() {
      const response = await originalFetch(
        cartUrl("cart.js"),
        {
          credentials: "same-origin",
          cache: "no-store"
        }
      );

      if (!response.ok) {
        throw new Error("Impossible de charger le panier");
      }

      return response.json();
    }

    async function getLocalizedProduct(item) {
      if (lang === "fr" || !item.handle) {
        return { title: item.product_title };
      }

      if (localizedProducts[item.handle]) {
        return localizedProducts[item.handle];
      }

      try {
        const response = await originalFetch(
          T.prefix + "/products/" + item.handle + ".js",
          { cache: "force-cache" }
        );

        if (!response.ok) throw new Error();

        const product = await response.json();
        localizedProducts[item.handle] = product;

        return product;
      } catch (error) {
        return { title: item.product_title };
      }
    }

    function openCart() {
      drawer.classList.add("mvd-open");
      overlay.classList.add("mvd-open");
      drawer.setAttribute("aria-hidden", "false");
      document.body.style.overflow = "hidden";

      refresh();
    }

    function closeCart() {
      drawer.classList.remove("mvd-open");
      overlay.classList.remove("mvd-open");
      drawer.setAttribute("aria-hidden", "true");
      document.body.style.overflow = "";
    }

    window.openMvdCart = openCart;

    closeButton.onclick = closeCart;
    overlay.onclick = closeCart;
    continueButton.onclick = closeCart;

    document.addEventListener(
      "click",
      function(event) {
        const element = event.target instanceof Element
          ? event.target
          : event.target.parentElement;

        if (!element) return;

        if (element.closest("#mvd-cart-drawer")) {
          return;
        }

        const trigger = element.closest(
          'a[href*="/cart"],' +
          'button[aria-controls*="cart" i],' +
          '[aria-label*="cart" i],' +
          '[aria-label*="panier" i]'
        );

        if (!trigger) return;

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        openCart();
      },
      true
    );

    // Détecter les ajouts au panier du thème Impact.
    window.fetch = function(resource, options) {
      let url = "";

      if (typeof resource === "string") {
        url = resource;
      } else if (resource && resource.url) {
        url = resource.url;
      }

      const request = originalFetch(resource, options);

      if (/\/cart\/add(?:\.js)?(?:\?|$)/.test(url)) {
        request.then(function(response) {
          if (response && response.ok) {
            window.setTimeout(openCart, 120);
          }
        }).catch(function() {});
      }

      return request;
    };

    // Toutes les modifications Shopify passent dans
    // une seule file pour éviter les conflits sur mobile.
    function enqueueCartOperation(operation) {
      const task = cartOperation
        .catch(function() {})
        .then(operation);

      cartOperation = task.catch(function(error) {
        console.error("MVD opération panier :", error);
      });

      return task;
    }

    async function changeItem(key, quantity) {
      return enqueueCartOperation(async function() {
        await refreshOperation.catch(function() {});

        const response = await originalFetch(
          cartUrl("cart/change.js"),
          {
            method: "POST",
            credentials: "same-origin",
            headers: {
              "Content-Type": "application/json",
              "Accept": "application/json"
            },
            body: JSON.stringify({
              id: String(key),
              quantity: Number(quantity)
            })
          }
        );

        if (!response.ok) {
          throw new Error(
            "Shopify a refusé la modification : " +
            response.status
          );
        }

        await refresh();
        return true;
      });
    }

    async function addItem(variantId) {
      return enqueueCartOperation(async function() {
        await refreshOperation.catch(function() {});

        const response = await originalFetch(
          cartUrl("cart/add.js"),
          {
            method: "POST",
            credentials: "same-origin",
            headers: {
              "Content-Type": "application/json",
              "Accept": "application/json"
            },
            body: JSON.stringify({
              items: [{
                id: Number(variantId),
                quantity: 1
              }]
            })
          }
        );

        if (!response.ok) {
          throw new Error("Ajout au panier refusé");
        }

        await refresh();
        return true;
      });
    }

    function renderShipping(cart) {
      const total = Number(cart.total_price || 0);
      const progress = Math.min(
        100,
        total / T.threshold * 100
      );

      shippingProgress.style.width = progress + "%";

      shippingText.textContent = total >= T.threshold
        ? T.free
        : T.missing.replace(
            "{amount}",
            money(T.threshold - total)
          );
    }

    // Les boutons +, - et Supprimer sont gérés ici.
    // Ce gestionnaire reste actif même si les lignes
    // des produits sont reconstruites.
    items.addEventListener("click", async function(event) {
      const target = event.target instanceof Element
        ? event.target
        : event.target.parentElement;

      if (!target) return;

      const button = target.closest(
        ".mvd-minus, .mvd-plus, .mvd-remove"
      );

      if (!button) return;

      event.preventDefault();
      event.stopPropagation();

      if (button.disabled) return;

      const row = button.closest(".mvd-item");
      if (!row) return;

      const key = row.dataset.key;
      const quantity = Number(row.dataset.quantity || 0);

      if (!key) return;

      let newQuantity = quantity;

      if (button.classList.contains("mvd-minus")) {
        newQuantity = Math.max(0, quantity - 1);
      } else if (button.classList.contains("mvd-plus")) {
        newQuantity = quantity + 1;
      } else {
        newQuantity = 0;
      }

      row.querySelectorAll(
        ".mvd-minus, .mvd-plus, .mvd-remove"
      ).forEach(function(control) {
        control.disabled = true;
      });

      try {
        await changeItem(key, newQuantity);
      } catch (error) {
        console.error("MVD quantité / suppression :", error);

        await refresh();
      }
    });

    async function renderItems(cart) {
      items.innerHTML = "";

      if (!cart.items || cart.items.length === 0) {
        items.hidden = true;
        empty.hidden = false;
        upsell.hidden = true;
        return;
      }

      items.hidden = false;
      empty.hidden = true;
      upsell.hidden = false;

      for (const item of cart.items) {
        const localized = await getLocalizedProduct(item);

        const localizedTitle = localized && localized.title
          ? localized.title
          : item.product_title;

        const original = Number(
          item.original_line_price ??
          item.line_price ??
          0
        );

        const finalPrice = Number(
          item.final_line_price ??
          item.line_price ??
          0
        );

        const percentage = original > finalPrice &&
          original > 0
            ? Math.round(
                (original - finalPrice) / original * 100
              )
            : 0;

        const row = document.createElement("div");
        row.className = "mvd-item";

        // Ces données sont utilisées par les boutons
        // mobiles, sans recréer leurs événements.
        row.dataset.key = item.key;
        row.dataset.quantity = item.quantity;

        row.innerHTML = `
          <a class="mvd-item-image"
             href="${safeText(item.url)}">
            <img
              src="${safeText(item.image || "")}"
              alt="${safeText(localizedTitle)}"
              loading="lazy"
            >
          </a>

          <div class="mvd-item-center">
            <a class="mvd-item-name"
               href="${safeText(item.url)}">
              ${safeText(localizedTitle)}
            </a>

            ${
              item.variant_title &&
              item.variant_title !== "Default Title"
                ? `
                  <div class="mvd-item-variant">
                    ${safeText(item.variant_title)}
                  </div>
                `
                : ""
            }

            <div class="mvd-qty">
              <button
                type="button"
                class="mvd-minus"
                aria-label="Diminuer la quantité"
              >−</button>

              <span>${item.quantity}</span>

              <button
                type="button"
                class="mvd-plus"
                aria-label="Augmenter la quantité"
              >+</button>
            </div>

            <button
              type="button"
              class="mvd-remove"
            >${T.remove}</button>
          </div>

          <div class="mvd-item-right">
            <span class="mvd-item-price">
              ${money(finalPrice)}
            </span>

            ${
              original > finalPrice
                ? `
                  <span class="mvd-item-old-price">
                    ${money(original)}
                  </span>
                `
                : ""
            }

            ${
              percentage > 0
                ? `
                  <span class="mvd-save-percent">
                    ${T.save.replace(
                      "{percent}",
                      percentage
                    )}
                  </span>
                `
                : ""
            }
          </div>
        `;

        items.appendChild(row);
      }
    }

    // ==========================================
    // DÉTAIL DES RÉDUCTIONS
    // ==========================================

    function getDiscountDetails(cart) {
      const discounts = [];

      function addDiscount(name, amount) {
        const cleanName = String(name || "").trim();
        const cleanAmount = Math.max(
          0,
          Number(amount || 0)
        );

        if (!cleanName || cleanAmount <= 0) return;

        const existing = discounts.find(function(discount) {
          return discount.name.toLowerCase() ===
            cleanName.toLowerCase();
        });

        if (existing) {
          existing.amount += cleanAmount;
        } else {
          discounts.push({
            name: cleanName,
            amount: cleanAmount
          });
        }
      }

      (
        cart.cart_level_discount_applications || []
      ).forEach(function(app) {
        addDiscount(
          app.title || app.code,
          app.total_allocated_amount
        );
      });

      (cart.items || []).forEach(function(item) {
        (
          item.line_level_discount_allocations || []
        ).forEach(function(allocation) {
          const app = allocation.discount_application || {};

          addDiscount(
            app.title || app.code,
            allocation.amount
          );
        });
      });

      return discounts;
    }

    function getDiscountNames(cart) {
      return getDiscountDetails(cart).map(function(discount) {
        return discount.name;
      });
    }

    function renderDiscounts(cart) {
      const discounts = getDiscountDetails(cart);

      activeDiscountTags.innerHTML = "";

      if (discounts.length === 0) {
        activeDiscounts.hidden = true;
        return;
      }

      activeDiscounts.hidden = false;

      discounts.forEach(function(discount) {
        const row = document.createElement("div");
        row.className = "mvd-discount-row";

        row.innerHTML = `
          <span class="mvd-discount-tag">
            ${safeText(discount.name)}
          </span>

          <strong class="mvd-discount-amount">
            -${money(discount.amount)}
          </strong>
        `;

        activeDiscountTags.appendChild(row);
      });

      scheduleDiscountButtons();
    }

    // ==========================================
    // ÉCONOMIES ET TOTAL
    // ==========================================

    function renderSummary(cart) {
      let original = 0;
      let finalPrice = 0;

      (cart.items || []).forEach(function(item) {
        original += Number(
          item.original_line_price ??
          item.line_price ??
          0
        );

        finalPrice += Number(
          item.final_line_price ??
          item.line_price ??
          0
        );
      });

      const saving = Math.max(
        Number(cart.total_discount || 0),
        original - finalPrice
      );

      savingValue.textContent = saving > 0
        ? "-" + money(saving)
        : money(0);

      checkout.textContent = T.checkout.replace(
        "{total}",
        money(cart.total_price)
      );

      checkout.href = "/checkout";

      renderDiscounts(cart);
    }

    // ==========================================
    // CODE PROMO
    // ==========================================

    promoToggle.onclick = function() {
      promoOpen = !promoOpen;
      promoContent.hidden = !promoOpen;
      promoSymbol.textContent = promoOpen ? "−" : "+";
    };

    promoApply.onclick = async function() {
      const code = promoInput.value.trim();

      if (!code) {
        promoMessage.textContent = T.promoEmpty;
        return;
      }

      promoApply.disabled = true;
      promoApply.textContent = T.applying;
      promoMessage.textContent = "";

      try {
        await enqueueCartOperation(async function() {
          const response = await originalFetch(
            "/discount/" +
            encodeURIComponent(code) +
            "?redirect=/cart",
            {
              credentials: "same-origin",
              cache: "no-store"
            }
          );

          if (!response.ok) {
            throw new Error("Code promo non appliqué");
          }

          await new Promise(function(resolve) {
            setTimeout(resolve, 250);
          });

          await refresh();
        });

        const updated = currentCart || await getCart();

        const names = getDiscountNames(updated);

        const found = names.some(function(name) {
          return name.toLowerCase().includes(
            code.toLowerCase()
          );
        });

        promoMessage.textContent = found
          ? T.promoApplied
          : T.promoInvalid;

      } catch (error) {
        console.error("MVD code promo :", error);
        promoMessage.textContent = T.promoInvalid;
      } finally {
        promoApply.disabled = false;
        promoApply.textContent = T.apply;
      }
    };

    promoInput.addEventListener(
      "keydown",
      function(event) {
        if (event.key === "Enter") {
          event.preventDefault();
          promoApply.click();
        }
      }
    );

    // ==========================================
    // SUPPRESSION DES CODES PROMO MANUELS
    // ==========================================

    function getManualDiscounts(cart) {
      const names = new Set();

      function inspect(application) {
        if (!application) return;

        const type = String(
          application.type || ""
        ).toLowerCase();

        if (type !== "discount_code") return;

        const name = String(
          application.title ||
          application.code ||
          ""
        ).trim();

        if (name) {
          names.add(name.toLowerCase());
        }
      }

      (
        cart.cart_level_discount_applications || []
      ).forEach(inspect);

      (cart.items || []).forEach(function(item) {
        (
          item.line_level_discount_allocations || []
        ).forEach(function(allocation) {
          inspect(allocation.discount_application);
        });
      });

      return names;
    }

    let discountButtonTimer = null;

    function scheduleDiscountButtons() {
      clearTimeout(discountButtonTimer);

      discountButtonTimer = setTimeout(
        updateDiscountButtons,
        250
      );
    }

    async function updateDiscountButtons() {
      const rows = activeDiscountTags.querySelectorAll(
        ".mvd-discount-row"
      );

      if (!rows.length) return;

      const cart = currentCart;
      if (!cart) return;

      const manualCodes = getManualDiscounts(cart);

      rows.forEach(function(row) {
        const label = row.querySelector(
          ".mvd-discount-tag"
        );

        if (!label) return;

        const name = label.textContent
          .trim()
          .toLowerCase();

        const existing = row.querySelector(
          ".mvd-remove-discount"
        );

        if (!manualCodes.has(name)) {
          if (existing) existing.remove();
          return;
        }

        if (existing) return;

        const button = document.createElement("button");
        button.type = "button";
        button.className = "mvd-remove-discount";
        button.textContent = "×";

        button.setAttribute(
          "aria-label",
          lang === "fr"
            ? "Retirer cette remise"
            : lang === "es"
              ? "Eliminar este descuento"
              : "Remove this discount"
        );

        button.style.cssText = [
          "display:inline-flex",
          "align-items:center",
          "justify-content:center",
          "width:20px",
          "height:20px",
          "padding:0",
          "margin-left:7px",
          "border:1px solid #D9D9D9",
          "border-radius:50%",
          "background:#FFFFFF",
          "color:#555555",
          "font-size:17px",
          "cursor:pointer",
          "flex-shrink:0"
        ].join(";");

        button.onclick = async function(event) {
          event.preventDefault();
          event.stopPropagation();

          button.disabled = true;

          try {
            await enqueueCartOperation(async function() {
              const response = await originalFetch(
                cartUrl("cart/update.js"),
                {
                  method: "POST",
                  credentials: "same-origin",
                  headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                  },
                  body: JSON.stringify({
                    discount: ""
                  })
                }
              );

              if (!response.ok) {
                throw new Error("Suppression refusée");
              }

              await refresh();
            });
          } catch (error) {
            console.error(
              "MVD suppression remise :",
              error
            );
            button.disabled = false;
          }
        };

        label.insertAdjacentElement(
          "afterend",
          button
        );
      });
    }

    // ==========================================
    // CHARGEMENT DES ACCESSOIRES
    // ==========================================

    async function loadAccessories() {
      if (accessoryProducts !== null) {
        return accessoryProducts;
      }

      if (accessoryPromise) {
        return accessoryPromise;
      }

      accessoryPromise = (async function() {
        try {
          const response = await originalFetch(
            T.collection,
            { cache: "no-store" }
          );

          if (!response.ok) {
            throw new Error("Accessoires indisponibles");
          }

          const data = await response.json();

          accessoryProducts = data.products || [];

          return accessoryProducts;
        } catch (error) {
          console.error("MVD accessoires :", error);
          accessoryProducts = [];
          return [];
        } finally {
          accessoryPromise = null;
        }
      })();

      return accessoryPromise;
    }

    // ==========================================
    // BÉNÉFICES DES ACCESSOIRES
    // ==========================================

    function productBenefit(product) {
      const text = (
        (product.handle || "") + " " +
        (product.title || "")
      )
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");

      const benefit = function(fr, es, en) {
        return lang === "fr"
          ? fr
          : lang === "es"
            ? es
            : en;
      };

      if (
        text.includes("embouts-metalliques") ||
        text.includes("metal-tips") ||
        text.includes("puntas-metalicas")
      ) {
        return benefit(
          "⚡ Posez plusieurs diamants à la fois",
          "⚡ Coloca varios diamantes a la vez",
          "⚡ Place multiple diamonds at once"
        );
      }

      if (
        text.includes("valise") ||
        text.includes("60-cell") ||
        text.includes("60 compartimentos")
      ) {
        return benefit(
          "🧰 Rangez vos diamants et votre matériel",
          "🧰 Guarda tus diamantes y tu material",
          "🧰 Store your diamonds & tools"
        );
      }

      if (
        text.includes("56-cell") ||
        text.includes("56 compartimentos")
      ) {
        return benefit(
          "💎 Organisez et séparez facilement vos diamants",
          "💎 Organiza y separa fácilmente tus diamantes",
          "💎 Easily organize & separate your diamonds"
        );
      }

      if (
        text.includes("plateau") ||
        text.includes("sorting-tray") ||
        text.includes("tray") ||
        text.includes("bandeja")
      ) {
        return benefit(
          "🛡️ Plus pratique et limite les renversements",
          "🛡️ Más práctico y ayuda a evitar derrames",
          "🛡️ Easier to use and helps prevent spills"
        );
      }

      if (
        text.includes("classeur") ||
        text.includes("binder") ||
        text.includes("portfolio") ||
        text.includes("carpeta") ||
        text.includes("album")
      ) {
        return benefit(
          "🖼️ Protégez et rangez vos créations terminées",
          "🖼️ Protege y guarda tus creaciones terminadas",
          "🖼️ Protect & store your finished creations"
        );
      }

      if (
        text.includes("tablette-lumineuse") ||
        text.includes("light-pad") ||
        text.includes("light-board") ||
        text.includes("light-table") ||
        text.includes("lumineuse")
      ) {
        return benefit(
          "💡 Distinguez les symboles plus facilement",
          "💡 Distingue los símbolos más fácilmente",
          "💡 See the symbols more easily"
        );
      }

      if (
        text.includes("pince") ||
        text.includes("tweezer") ||
        text.includes("pinza")
      ) {
        return benefit(
          "🎯 Ajustez et retirez vos diamants avec précision",
          "🎯 Ajusta y retira tus diamantes con precisión",
          "🎯 Adjust & remove diamonds with precision"
        );
      }

      if (
        text.includes("cadre") ||
        text.includes("frame") ||
        text.includes("marco")
      ) {
        return benefit(
          "✨ Exposez votre création une fois terminée",
          "✨ Expón tu creación una vez terminada",
          "✨ Display your creation once finished"
        );
      }

      if (
        text.includes("boite") ||
        text.includes("storage") ||
        text.includes("box") ||
        text.includes("rangement") ||
        text.includes("caja")
      ) {
        return benefit(
          "💎 Gardez votre matériel parfaitement organisé",
          "💎 Mantén todo tu material perfectamente organizado",
          "💎 Keep your supplies perfectly organized"
        );
      }

      return benefit(
        "✨ Rendez votre Diamond Painting encore plus agréable",
        "✨ Haz que tu Diamond Painting sea aún más agradable",
        "✨ Make your Diamond Painting experience even better"
      );
    }

    // ==========================================
    // AFFICHAGE DES ACCESSOIRES
    // ==========================================

    async function renderUpsell(cart) {
      const products = await loadAccessories();

      slider.innerHTML = "";

      if (!cart.items || !cart.items.length) {
        upsell.hidden = true;
        return;
      }

      const cartIds = cart.items.map(function(item) {
        return Number(item.product_id);
      });

      products.forEach(function(product) {
        if (cartIds.includes(Number(product.id))) {
          return;
        }

        const variant = (
          product.variants || []
        ).find(function(v) {
          return v.available;
        }) || (product.variants || [])[0];

        if (!variant) return;

        const productPrice = Math.round(
          parseFloat(variant.price || 0) * 100
        );

        const comparePrice = variant.compare_at_price
          ? Math.round(
              parseFloat(variant.compare_at_price) * 100
            )
          : 0;

        const salePercent = comparePrice > productPrice
          ? Math.round(
              (comparePrice - productPrice) /
              comparePrice * 100
            )
          : 0;

        let image = "";

        if (product.images && product.images.length) {
          image = product.images[0].src ||
            product.images[0];
        }

        const productUrl = T.prefix +
          "/products/" +
          product.handle;

        const card = document.createElement("div");
        card.className = "mvd-upsell-card";

        const saleBadge = salePercent > 0
          ? `
            <span class="mvd-upsell-sale-badge">
              ${T.sale.replace("{percent}", salePercent)}
            </span>
          `
          : "";

        const oldPrice = salePercent > 0
          ? `
            <span class="mvd-upsell-old-price">
              ${money(comparePrice)}
            </span>
          `
          : "";

        card.innerHTML = `
          <a
            class="mvd-upsell-image-wrap"
            href="${safeText(productUrl)}"
          >
            ${saleBadge}

            <img
              src="${safeText(image)}"
              alt="${safeText(product.title)}"
              loading="lazy"
            >
          </a>

          <div>
            <a
              class="mvd-upsell-name"
              href="${safeText(productUrl)}"
            >
              ${safeText(product.title)}
            </a>

            <span class="mvd-upsell-benefit">
              ${productBenefit(product)}
            </span>

            <div class="mvd-upsell-prices">
              <span class="mvd-upsell-price">
                ${money(productPrice)}
              </span>

              ${oldPrice}
            </div>

            <button
              type="button"
              class="mvd-upsell-add"
            >
              ${T.add}
            </button>
          </div>
        `;

        const button = card.querySelector(
          ".mvd-upsell-add"
        );

        button.onclick = async function(event) {
          event.preventDefault();
          event.stopPropagation();

          if (button.disabled) return;

          button.disabled = true;
          button.textContent = T.adding;

          try {
            await addItem(variant.id);
          } catch (error) {
            console.error("MVD ajout accessoire :", error);
          } finally {
            if (button.isConnected) {
              button.disabled = false;
              button.textContent = T.add;
            }
          }
        };

        slider.appendChild(card);
      });
    }

    // ==========================================
    // NAVIGATION DES ACCESSOIRES
    // ==========================================

    prev.onclick = function() {
      slider.scrollBy({
        left: -330,
        behavior: "smooth"
      });
    };

    next.onclick = function() {
      slider.scrollBy({
        left: 330,
        behavior: "smooth"
      });
    };

    // ==========================================
    // ACTUALISATION DU PANIER
    // ==========================================

    function refresh() {
      const task = refreshOperation
        .catch(function() {})
        .then(async function() {
          const cart = await getCart();

          currentCart = cart;

          renderShipping(cart);

          await renderItems(cart);

          renderSummary(cart);

          await renderUpsell(cart);
        });

      refreshOperation = task.catch(function(error) {
        console.error("MVD actualisation panier :", error);
      });

      return refreshOperation;
    }

    // ==========================================
    // ÉVÉNEMENTS SHOPIFY / IMPACT
    // ==========================================

    document.addEventListener(
      "cart:refresh",
      refresh
    );

    document.addEventListener(
      "cart:updated",
      refresh
    );

    document.addEventListener(
      "mvd:cart-refresh",
      refresh
    );

    document.addEventListener(
      "mvd:cart-open",
      openCart
    );

    // Chargement initial
    refresh();
  }

  // ==========================================
  // INITIALISATION UNIQUE
  // ==========================================

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initMvdCart,
      { once: true }
    );
  } else {
    initMvdCart();
  }

})();
